import React from 'react';
import PropTypes from 'prop-types';
import _ from "underscore";

// Loops, loops, loops
// NOSONAR: `category` and `label` are Blockly toolbox-XML pseudo-elements,
// not real DOM elements. Attributes like `iconclass` and `text` are valid
// Blockly toolbox attributes.
const Loops = ({ blocks, context }) => {
    const childBlocks = _.map(blocks, ({ component: BlockComponent }, blockKey) => (
        <BlockComponent context={context} key={blockKey}/>
    ));

    if (childBlocks.length > 0) {
        return (
            <category name='Loops' id='loops' iconclass='category with-icon-paths snap-icon-loop_dual'>{/* NOSONAR */}
                <label text="Loops"></label>{/* NOSONAR */}
                { childBlocks }
            </category>
        );
    }

    return null;
};

Loops.propTypes = {
    blocks: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
};

export default Loops;